import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { fetchCategoriesAction } from '@helpcenter/common-actions';
import type { State } from '@helpcenter/common-state-selectors';
import { getCategories } from '@helpcenter/common-state-selectors/src/portal';
import CategoryFilterComponent from './category-filter';

interface ExternalProps {
	portalId: number;
}

const selector = createSelector(
	(state: State, props: ExternalProps) => getCategories(state, props.portalId),
	(maybeCategories) => {
		const categories = Array.isArray(maybeCategories) ? maybeCategories : [];
		return {
			categories,
		};
	},
);

const CategoryFilter = connect(selector, {
	fetchCategories: fetchCategoriesAction,
})(CategoryFilterComponent);

export default CategoryFilter;
